const SVGCard = {
  use: (rank, suit) => `<use xlink:href="#card-${rank}${suit}"></use>`,
    svg: function(klass, rank, suit) {
      const use = SVGCard.use(rank, suit)
      return `<svg class="svg-card suit-${suit} rank-${rank} card-${rank}${suit} ${klass}" viewbox="0 0 225 314">${use}</svg>`
    },
  mini: {
    byRankSuit: (rank, suit) => SVGCard.svg('mini-card', rank, suit)
  }
}

export default SVGCard
